/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("DragDropInfoController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class DragDropInfoController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class DragDropInfoController extends cls.ControllerBase /** @lends classes.DragDropInfoController.prototype */ {
    static __name = "DragDropInfoController";

    /**
     * @param {ControllerBindings} bindings
     */
    constructor(bindings) {
      super(bindings);

      const anchor = this.getNodeBindings().anchor;
      // vm behaviors
      this._addBehavior(cls.DndAcceptedVMBehavior);

      context.DndService.setDragDropInfoNode(anchor);
      context.DndService.setDndAccepted(false);
    }

    /**
     * @inheritdoc
     */
    destroy() {
      super.destroy();

      context.DndService.setDragDropInfoNode(null);
      context.DndService.setDndAccepted(false);
    }

    /**
     * DragDropInfo don't create widgets
     */
    createWidget() {
      return null;
    }
  }

  cls.DragDropInfoController = DragDropInfoController;
  cls.ControllerFactory.register("DragDropInfo", cls.DragDropInfoController);
});
